import {
  FormControl,
  makeStyles,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";
import { StatusDistributionService } from "../../../services/statusDistribution.service";
import styles from "../../../styles/global-styles";

const usetSyles = makeStyles((theme) => ({
  label: styles.label,
  customSelect: styles.customSelect,
  table: {
    minWidth: 750,
  },
}));

const StatusDistributionSelect = ({
  addAlert,
  detailAlert,
  status,
  showAllStatus,
  confirmDistribution,
  cleanValue,
}) => {
  const classes = usetSyles();

  const [statusArray, setstatusArray] = React.useState([]);
  const [statusSelected, setstatusSelected] = React.useState("");

  useEffect(() => {
    (async function () {
      try {
        const {
          data,
        } = await StatusDistributionService.getAllStatusDistributions();
        if (confirmDistribution) {
          setstatusArray(
            data.filter(
              (item) => item.id === 2 || item.id === 3 || item.id === 5
            )
          );
        } else if (showAllStatus) {
          setstatusArray(data);
        } else {
          /* Remove status 'Cancelada' */
          setstatusArray(data.filter((item) => item.id !== 4));
        }
      } catch (error) {
        console.log(error);
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  useEffect(() => {
    if (cleanValue) setstatusSelected("");
  }, [cleanValue]);

  useEffect(() => {
    if (statusSelected.length !== 0) {
      status("statusDistributionId", statusSelected);
    }
  }, [statusSelected]);

  const handleFormInput = ({ target: { value } }) => setstatusSelected(value);

  return (
    <>
      {statusArray.length > 0 && (
        <FormControl variant="outlined" className={classes.formControl}>
          <Typography
            variant="body2"
            component={"div"}
            className={classes.label}
          >
            Estatus:
          </Typography>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="status"
            value={statusSelected}
            className={classes.customSelect}
            onChange={(e) => handleFormInput(e)}
          >
            {!confirmDistribution && (
              <MenuItem value="none">
                <em>-TODOS-</em>
              </MenuItem>
            )}
            {statusArray.map((item, i) => {
              return (
                <MenuItem key={i} value={item.id || ""}>
                  {item.status}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(StatusDistributionSelect);
